import * as locales from '~/i18n/locales';

const localTranslations = Object.values(locales).reduce((acc, locale) => {
  acc[locale.lang] = locale.translation;
  return acc;
}, {});

export const getLocalTranslation = (key, lang) => {
  const baseLang = lang?.split('-')[0] || 'en';
  const keys = key.split('.');
  const value = keys.reduce(
    (acc, k) => acc?.[k],
    localTranslations[baseLang] || localTranslations.en
  );
  return value || null;
};

export const getTranslationWithLocalFallback = (t, key, lang) => {
  const translated = t(key);
  if (translated !== key) return translated;
  return getLocalTranslation(key, lang) || translated;
};
